import { AfterViewInit, Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { I360Service } from 'src/Services/i360Service';
import { FilterModel } from 'src/Models/filterModel';
import { CheckAuth } from 'src/Services/utility.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { WhitepaperSectionsModel, WhitePapersModel } from 'src/Models/WhitePapersModel';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import * as DOMPurify from 'dompurify';

declare var $: any;

@Component({
  selector: 'app-white-papers',
  templateUrl: './white-papers.component.html',
  styleUrls: ['./white-papers.component.css']
})
export class WhitePapersComponent implements OnInit, AfterViewInit, OnDestroy {

  listOfWhitePapers: WhitePapersModel[];
  filterModel = new FilterModel();
  tokenKey: string = '';
  _userID: any;

  currentPage: number = 1;
  totalRecordCount: number = -1;
  keywordFilter: string = '';
  OrderBy: string = '';
  isAscending: boolean = false
  isShowprogressSpinner: boolean;
  blockedDocument: boolean;
  // videoURL: string;
  videoType: string;
  @ViewChild("videoPlayer", { static: false }) videoplayer: ElementRef;
  @ViewChild("videoModel", { static: false }) videoModel: ElementRef;
  @ViewChild("whitePapersVideoModal", { static: false }) whitePapersVideoModal: ElementRef;
  topicTitle: string = ''
  isEmbed: boolean = false;
  videoURL: any;
  listOfSpecialReportSection: WhitepaperSectionsModel[];
  groupArr: any[];
  isloading: boolean = false;

  constructor(private readonly i360Service: I360Service,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private readonly appActivity: ApplicationActivityService,
    private readonly sanitizer: DomSanitizer,
    private readonly ngZone: NgZone) {
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
    this._userID = sessionStorage.getItem('UserId');
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '500';
    this.filterModel.orderBy = 'SectionSortOrder,SortOrder';
    this.filterModel.userID = this._userID;
    this.filterModel.productId = ToolEnum.whitepapers;
    this.titleService.setTitle('White Papers | JSi360');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.i360WhitePapersGet();
  }

  ngAfterViewInit() {
    $(this.whitePapersVideoModal.nativeElement).on('hidden.bs.modal.whitePapers', () => {
      this.ngZone.run(() => this.unloadVideoPlayer());
    });
  }

  ngOnDestroy() {
    if (this.whitePapersVideoModal && this.whitePapersVideoModal.nativeElement) {
      $(this.whitePapersVideoModal.nativeElement).off('hidden.bs.modal.whitePapers');
    }
  }

  i360WhitePapersGet() {
    this.isloading = true;
    this.i360Service.i360WhitePapersGet(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        this.listOfWhitePapers = data['listOfWhitePapers'];

        this.groupArr = this.listOfWhitePapers.reduce((r, { sectionName }) => {
          if (!r.some(o => o.sectionName == sectionName)) {
            r.push({ sectionName, groupItem: this.listOfWhitePapers.filter(v => v.sectionName == sectionName) });
          }
          return r;
        }, []);

        if (this.listOfWhitePapers != null) {
          if (this.listOfWhitePapers.length > 0) {
            this.totalRecordCount = this.listOfWhitePapers[0].totalRecordCount;
          }
          else {
            this.totalRecordCount = 0;
          }
        }
        else {
          this.totalRecordCount = 0;
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  donwloadFile(data: WhitePapersModel) {
    this.topicTitle = '';
    this.isEmbed = data.isEmbed;
    if ((!data.docPath || data.isLocked) && !data.isEmbed)
      return;

    if (data.isLocked)
      return;

    this.topicTitle = data.title;

    if (data.linktype == 1 || data.linktype == 0) {
      if (data.isEmbed) {
        ApplicationActivityStore('View', 'White Papers', this.appActivity, data.whitePaperId, ActionActivity['White Papers'], data.title);
        if (data.externalURL.includes('youtube')) {
          this.videoURL = data.externalURL;
          const cleanURL = DOMPurify.sanitize(data.externalURL);
          this.videoURL = this.sanitizer.bypassSecurityTrustResourceUrl(cleanURL);
          this.videoModel.nativeElement.click();
        }
        else {
          window.open(data.externalURL, '_blank');
        }
      }
    }

    else if (data.linktype == 2) {
      const extension = data.docPath.split(".").pop();
      if (extension == 'ogg' || extension == 'ogv' || extension == 'mp4' || extension == 'webm') {
        ApplicationActivityStore('View', 'White Papers', this.appActivity, data.whitePaperId, ActionActivity['White Papers'], data.title);
        this.videoType = 'video/' + extension;
        const cleanURL = DOMPurify.sanitize(data.docPath);
        this.videoURL = this.sanitizer.bypassSecurityTrustResourceUrl(cleanURL);
        this.videoModel.nativeElement.click();
        const player = this.videoplayer ? this.videoplayer.nativeElement : null;
        if (player && typeof player.load === 'function') {
          player.load();
          player.play();
        }
      }

      else {
        ApplicationActivityStore('Download', 'White Papers', this.appActivity, data.whitePaperId, ActionActivity['White Papers'], data.displayDocName)
        this.isShowprogressSpinner = true;
        this.blockedDocument = true;
        this.i360Service.DownloadDocument(this.tokenKey, { DocType: 'whitepapers', DocPath: data.docPath }).subscribe(
          fileData => {
            this.isShowprogressSpinner = false;
            this.blockedDocument = false;
            if (fileData != null) {
              FileSaver.saveAs(fileData, data.displayDocName);
              this.toastr.success('File downloaded successfully', 'File Downloaded')
            }
          }, error => {
            this.isShowprogressSpinner = false;
            this.blockedDocument = false;
            console.log(error);
          });
      }
    }
  }

  closeVideoPlayer() {
    this.unloadVideoPlayer();
  }

  private unloadVideoPlayer() {
    const player = this.videoplayer ? this.videoplayer.nativeElement : null;
    if (player && typeof player.pause === 'function') {
      player.pause();
      player.currentTime = 0;
    }
    this.videoURL = null;
    this.isEmbed = false;
  }

  toggleVideo(event: any) {
    var myVideo: any = this.videoplayer.nativeElement
    if (myVideo.paused) myVideo.play();
    else myVideo.pause();
  }

  pageChanged($event: any) {
    this.filterModel.pageNumber = $event.page;
    this.currentPage = $event.page;
    this.i360WhitePapersGet();
  }
}
